import { render } from "./PatientSelectInput.vue?vue&type=template&id=370f0361&scoped=true"
import script from "./PatientSelectInput.vue?vue&type=script&lang=js"
export * from "./PatientSelectInput.vue?vue&type=script&lang=js"

import "./PatientSelectInput.vue?vue&type=style&index=0&id=370f0361&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370f0361"]])

export default __exports__